import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-werte',
  templateUrl: './werte.component.html',
  styleUrls: ['./werte.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class WerteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
